import { SegmentedControl, StaticMenuLayout } from '@vake/ui-kit';
import { FC, ReactNode } from 'react';
import { useOverwatchContext } from '../../interactiveReport/overwatch-2-context';
import { Filters } from './filters';
import { Menu } from './menu';
import { Settings } from './settings';

type Props = {
    topChildren?: ReactNode;
};
export const LeftBar: FC<Props> = ({ topChildren }) => {
    const {
        report: { name },
        view: { selected, setSelected },
    } = useOverwatchContext();
    return (
        <StaticMenuLayout title={name} menuChildren={<Menu />} topChildren={topChildren}>
            <div className="flex flex-col h-[calc(100vh-240px)] overflow-y-auto">
                <SegmentedControl selected={selected} setSelected={setSelected}>
                    <SegmentedControl.Item label="Filters">
                        <Filters />
                    </SegmentedControl.Item>
                    <SegmentedControl.Item label="Settings">
                        <Settings />
                    </SegmentedControl.Item>
                </SegmentedControl>
            </div>
        </StaticMenuLayout>
    );
};
